export default {"src":"/_next/static/media/section2.fdc25b21.svg","height":553,"width":951,"blurWidth":0,"blurHeight":0};